import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';

export default class FormTextArea extends Component {
  render() {
    const { placeholder, label, input, controlId, disabled, meta } = this.props;

    return (
      <FormGroup controlId={controlId || ''}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl
          componentClass="textarea"
          value={input.value}
          onChange={input.onChange}
          placeholder={placeholder || ''}
          disabled={disabled}
          {...input}
        />
        {meta.error && <HelpBlock>{meta.error}</HelpBlock>}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}

FormTextArea.propTypes = {
  label: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.object,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/cms/form/FormTextArea.js